/**
 * Empty/default form values used when creating a new property.
 * Typed as PropertyFormValues by the schema module re-export.
 */
export const DEFAULT_VALUES = {
  category: '',
  transaction_type: [] as string[],
  postal_code: '',
  street: '',
  number: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
  total_area: undefined as number | undefined,
  constructed_area: undefined as number | undefined,
  sale_price: undefined as number | undefined,
  rental_price: undefined as number | undefined,
  condominium_price: undefined as number | undefined,
  iptu: undefined as number | undefined,
  bedrooms: undefined as number | undefined,
  suites: undefined as number | undefined,
  bathrooms: undefined as number | undefined,
  parking_spots: undefined as number | undefined,
  floor: undefined as number | undefined,
  fixed_parking: false,
  gourmet_balcony: false,
  balcony: false,
  accepts_pets: false,
  furnished: undefined as string | undefined,
  facing: undefined as string | undefined,
  year_built: undefined as number | undefined,
  parking_type: undefined as string | undefined,
  total_rooms: undefined as number | undefined,
  accepts_exchange: false,
  rental_payment_frequency: undefined as string | undefined,
  rental_included_expenses: [] as string[],
  administration_type: undefined as string | undefined,
  condo_included_expenses: [] as string[],
  condo_paid_by: undefined as string | undefined,
  leisure_areas: [] as string[],
  facilities: [] as string[],
  security: [] as string[],
  infrastructure: [] as string[],
  highlights: [] as string[],
  condominium: false,
  condo_amenities: [] as string[],
  condo_security: [] as string[],
  rental_guarantee: [] as string[],
  admin_percentage: undefined as number | undefined,
  lease_term_in_months: 30,
  tags: [] as string[],
  property_title: '',
  property_code: '',
  property_code_initial: '',
  description: '',
  virtual_tour_url: undefined as string | undefined,
  video_links: [] as string[],
  registration_number: undefined as string | undefined,
  registry_office: undefined as string | undefined,
  inscription_number: undefined as string | undefined,
  owner_client_id: undefined as string | undefined,
  mandate_type: undefined as string | undefined,
  mandate_start_date: undefined as string | undefined,
  mandate_end_date: undefined as string | undefined,
  mandate_commission: undefined as number | undefined,
  primary_broker: undefined as string | undefined,
  captured_by: undefined as string | undefined,
  assigned_brokers: [] as string[],
  condominium_name: undefined as string | undefined,
  tower_name: undefined as string | undefined,
  development_name: undefined as string | undefined,
  developer: undefined as string | undefined,
  distance_to_sea_m: undefined as number | undefined,
  block: undefined as string | undefined,
  unit: undefined as string | undefined,
  quadra: undefined as string | undefined,
  lot: undefined as string | undefined,
  short_term_price: undefined as number | undefined,
  short_term_guests: undefined as number | undefined,
  short_term_cleaning_fee: undefined as number | undefined,
  auction_first_date: undefined as string | undefined,
  auction_first_price: undefined as number | undefined,
  auction_second_date: undefined as string | undefined,
  auction_second_price: undefined as number | undefined,
  condition: undefined as string | undefined,
  occupancy: undefined as string | undefined,
  finish_standard: undefined as string | undefined,
  location_quality: undefined as string | undefined,
  exclusive: undefined as string | undefined,
  exclusive_until: undefined as string | undefined,
  publish_authorized: undefined as string | undefined,
  publish_authorized_until: undefined as string | undefined,
  key_location: undefined as string | undefined,
  partner_name: undefined as string | undefined,
};
